import { Component, OnInit } from "@angular/core";
import { SetupWizardService } from "@services/setup-wizard.service";
import { tap } from "rxjs/operators";
import { Subscription } from "rxjs";

@Component({
  selector: "app-wizard-integration-create",
  templateUrl: "./wizard-integration-create.component.html",
  styleUrls: [
    "./wizard-integration-create.component.scss",
    "../../wizard-styles.scss",
  ],
})
export class WizardIntegrationCreateComponent implements OnInit {
  public socketSubscription: Subscription;
  public status: string = "";
  public showHiddenInput = false;
  public integrationInput$;
  public integrationForm;
  isProcessing = false;
  socket$: any;
  constructor(private wizardService: SetupWizardService) {}

  ngOnInit(): void {

    this.integrationInput$ = this.wizardService.integrationInput$.pipe(
      tap(({ status, input, isProcessing }) => {
        this.integrationForm = input;
        this.status = status;
        this.isProcessing = isProcessing;
      })
    );
    this.wizardService.openSocket();
  }

  createIntegration() {
    this.integrationForm.disable();
    this.wizardService.createIntegration().subscribe();
  }
}
